import { Icon, forwardRef } from "@chakra-ui/react";
import * as React from "react";
export const SvgCheckmarkIcon = forwardRef((props, ref) => {
  return /* @__PURE__ */ React.createElement(Icon, { ref, color: "foreground.secondary", fill: "none", fill: "none", height: 16, viewBox: "0 0 16 16", width: 16, xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.3337 4.43945L6.00033 11.7728L2.66699 8.43945", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5 }));
});
export default SvgCheckmarkIcon;
